{{ value | date: format }}
